import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

export const revalidate = 0;

const StoriaPage = () => {
    const { t } = useTranslation();

    const sections = [
        {
          textKey: "storia.storia-1",
          image: "/beverahills_vigneto_4.webp",
        },
        {
          textKey: "storia.storia-2",
          image: "/beverahills_vigneto_5.webp",
        },
        {
          textKey: "storia.storia-3",
          image: "/beverahills_vigneto_6.webp",
        },
        {
            textKey: "storia.storia-4",
            image: "/beverahills_vini_cantina.jpg",
        },
        {
          textKey: "storia.storia-5",
          image: "/beverahills_vigneto_7.webp",
        },
    ];

    return (
        <div className="md:max-w-[80%] 3xl:max-w-full mx-auto">
           <h1 className="text-4xl font-light text-gray-800 titolo mb-4 text-center">
               {t("storia.titolo")}
           </h1>
            {sections.map((section, index) => (
                <motion.div
                    key={index}
                    className={`flex flex-col md:flex-row items-center py-8 ${
                        index % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse "
                    }`}
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }} 
                >
                    <img
                        src={section.image}
                        alt={t("storia.alt_vigneto_sezione")}
                        className="w-full md:w-1/2 rounded-2xl shadow-lg "
                    />
                    <div className="w-full md:w-1/2 p-6 md:ml-6 md:mr-6 shadow-md shadow-verde_scuro rounded-xl">
                        <p className="text-lg text-gray-700 font-medium whitespace-pre-line">
                            {t(section.textKey)}
                        </p>
                    </div>
                </motion.div>
            ))}
            <div className="text-center mt-10 shadow-md shadow-verde_chiaro p-6 rounded-2xl md:mx-8">
                <h2 className="text-xl md:text-2xl font-semibold">
                    {t("storia.storia-6")}
                </h2>
                <h2 className="text-xl md:text-2xl font-medium mt-2">
                    {t("storia.storia-7")}
                </h2>
            </div>
            <img 
                src="/beverahills_vigneto_8.webp" 
                alt={t("storia.alt_vigneto_panoramica_finale")} 
                className="my-10 rounded-2xl shadow-lg" 
            />
        </div>
    );
};

export default StoriaPage;